"use client";
import { jsxs as g, jsx as t } from "react/jsx-runtime";
import { cva as s } from "class-variance-authority";
import { useState as x } from "react";
import { BadgeButton as h } from "./BadgeButton.mjs";
import { cn as a } from "../../../utils/utils.mjs";
import { Text as w } from "../Text/Text.mjs";
const b = s("flex justify-center items-center", {
  variants: {
    size: {
      small: "px-1.5 py-0.5",
      medium: "px-1.5 py-0.5",
      large: "px-2 py-1.5"
    },
    color: {
      // include colors for hover state when theres a close button, work with design
      neutral: "bg-white text-gray-900",
      info: "bg-blue-700 text-white",
      success: "bg-green-700 text-white",
      warning: "bg-pink-700 text-white"
    },
    shape: {
      rounded: "rounded-full",
      square: "rounded"
    }
  },
  defaultVariants: {
    size: "small",
    color: "info"
  }
}), z = s("fill-current", {
  variants: {
    size: {
      small: "w-2.5 h-2.5",
      medium: "w-3.5 h-3.5",
      large: "w-4 h-4"
    }
  }
}), v = s("", {
  variants: {
    textCase: {
      capitalize: "capitalize",
      uppercase: "uppercase",
      lowercase: "lowercase"
    }
  }
}), k = ({
  className: i,
  color: n = "info",
  hasCloseButton: l = !1,
  Icon: r = null,
  shape: o = "square",
  size: e = "medium",
  text: c = "New",
  textCase: u = "capitalize",
  fontWeight: m = "regular"
}) => {
  const [p, f] = x(!0), d = {
    small: "xs",
    medium: "sm",
    large: "base"
  }[e] || "base";
  return p ? /* @__PURE__ */ g("div", { className: a(b({ size: e, color: n, shape: o }), "gap-1", i), children: [
    r && /* @__PURE__ */ t(r, { className: a(z({ size: e })) }),
    /* @__PURE__ */ t(w, { asChild: !0, fontWeight: m, fontSize: d, className: a(v({ textCase: u })), children: /* @__PURE__ */ t("span", { children: c }) }),
    l ? /* @__PURE__ */ t(h, { size: e, onClick: () => f(!1) }) : null
  ] }) : null;
};
export {
  k as Badge,
  b as badgeVariants
};
